import { UploadSimpleIcon } from "@phosphor-icons/react/dist/csr/UploadSimple";
import { Button } from "@volca/ui/components/ui/button";
import { Spinner } from "@volca/ui/components/ui/spinner";
import { formatMoneyCents } from "@/core/utils/money";
import { useStAdjustmentsSection } from "./st-adjustments-section";

/**
 * The PushPay control for the page header's section slot.
 *
 * Renders nothing until the run has a pushable line, so an untagged period
 * leaves the header alone.
 */
export const StAdjustmentsHeaderActions = () => {
  const { hasRows, push, pushExpected, pushCents, selection, stagePush } =
    useStAdjustmentsSection();

  if (!hasRows) return null;

  return (
    <Button
      disabled={pushExpected === 0 || push.isBusy}
      onClick={stagePush}
      aria-busy={push.isBusy || undefined}
    >
      {push.isBusy ? (
        <Spinner data-icon="inline-start" aria-hidden />
      ) : (
        <UploadSimpleIcon data-icon="inline-start" />
      )}
      {push.isActive
        ? "Pushing…"
        : pushExpected === 0
          ? "Nothing to push"
          : selection.hasSelection
            ? `Push ${pushExpected} · ${formatMoneyCents(pushCents) ?? "$0"}`
            : `Push all ${pushExpected} · ${formatMoneyCents(pushCents) ?? "$0"}`}
    </Button>
  );
};
